import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { PageTrackingContext } from '../../contexts/PageTrackingContext';

const GUARD_TIMEOUT_MS = 500;

export const PageTrackingGuard = () => {
  const location = useLocation();
  const { setNotifier } = useContext(PageTrackingContext);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return undefined;

    let tracked = false;
    setNotifier(() => {
      tracked = true;
    });

    const timer = setTimeout(() => {
      if (!tracked) {
        // eslint-disable-next-line no-console
        console.warn(
          `No PageImpression detected for route "${location.pathname}". ` +
            'Wrap your page component with <PageImpression> or withPageImpression().',
        );
      }
      setNotifier(null);
    }, GUARD_TIMEOUT_MS);

    return () => {
      clearTimeout(timer);
      setNotifier(null);
    };
  }, [location.pathname, setNotifier]);

  return null;
};
